var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-dashboard"},[_c('b-tabs',{staticClass:"profile-options",attrs:{"card":""},model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},[_c('b-tab',{attrs:{"no-body":"","title":_vm.$t('lang.contrasenia.msg')}},[(_vm.tabIndex == 0)?_c('ProfileChangePasswordForm'):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }